

























































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import {
  ShopItemDefinition,
  ShopItemOptionDefinition,
  ShopItemOptionMultipleChoiceDefinition,
  ShopItemOptionCardDefinition,
} from "@/store/states/ShopState";
import shopItemRawDefinitions from "@/assets/shop-items-definitions.json";
import MultipleChoiceOption from "@/components/shop/options/MultipleChoiceOption.vue";
import CardImageOption from "@/components/shop/options/CardImageOption.vue";
import QuantityOption from "@/components/shop/options/QuantityOption.vue";
import { CartState } from "@/store/states/CartState";
import Model3D from "@/components/configurator/Model3D.vue";
import { RevolvaService } from "@/components/configurator/revolva.service";
import * as actions from "@/components/configurator/revolva.action";
import { MetaInfo } from "vue-meta";

@Component<Shop>({
  components: {
    MultipleChoiceOption,
    CardImageOption,
    QuantityOption,
    Model3D,
  },
  metaInfo(): MetaInfo {
    return{
      // if no subcomponents specify a metaInfo.title, this title will be used
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      title: "SWISS ECO BAGS ™ | " + (this as any).$i18n.t("appbar.shop"),
      meta: [
        {
          vmid: "description",
          name: "description",
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          content: (this as any).$i18n.t("shop.description"),
        },
      ],
    }
  },
})
export default class Shop extends Vue {
  @State("cart") cart: CartState;
  @Action("init", { namespace: "cart" }) initCart: Function;
  @Action("loadOrCreateShopItem", { namespace: "cart" })
  loadOrCreateShopItem: Function;
  @Prop(Number) step: number;
  public productId = 0;
  public revolva = new RevolvaService(this.productId);

  shopItemDefinition!: ShopItemDefinition;
  currentOption!: ShopItemOptionDefinition;
  shopItemDefinitionsOptions: ShopItemOptionDefinition[] = [];
  productUUID = "999f6c2e-ae8f-4b8d-98bf-0a7b8d7eebae";

  created() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    for (const item of shopItemRawDefinitions["options"] as any) {
      if (item.type === "multipleChoice") {
        this.shopItemDefinitionsOptions.push(
          item as ShopItemOptionMultipleChoiceDefinition
        );
      } else if (item.type === "card") {
        this.shopItemDefinitionsOptions.push(
          item as ShopItemOptionCardDefinition
        );
      } else {
        this.shopItemDefinitionsOptions.push(item as ShopItemOptionDefinition);
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    for (const item of shopItemRawDefinitions["items"] as any) {
      if (item.uuid === this.productUUID) {
        this.shopItemDefinition = item;
        this.loadOption();
        break;
      }
    }
    this.initCart();
    this.loadOrCreateShopItem(this.productUUID);
  }

  @Watch("step", {})
  loadOption() {
    if (this.step === undefined) {
      this.currentOption = this.shopItemDefinitionsOptions.find(
        (x) => x.uuid === this.shopItemDefinition.options[0]
      );
      this.step = 0;
    } else if (this.step < this.shopItemDefinition.options.length) {
      this.currentOption = this.shopItemDefinitionsOptions.find(
        (x) => x.uuid === this.shopItemDefinition.options[this.step]
      );
    }
  }

  next() {
    this.$router.push({
      name: "Shop",
      params: { step: "" + ((this.step === undefined ? 0 : this.step) + 1) },
    });
  }

  previous() {
    this.$router.push({
      name: "Shop",
      params: {
        step:
          "" + (this.step === undefined || this.step === 0 ? 0 : this.step - 1),
      },
    });
  }

  previousOption() {
    const currentIndex = this.shopItemDefinition.options.indexOf(
      this.currentOption.uuid
    );
    if (currentIndex - 1 >= 0) {
      const previousOption = this.shopItemDefinitionsOptions.find(
        (x) => x.uuid === this.shopItemDefinition.options[currentIndex - 1]
      );
      return previousOption.nameTranslationKey;
    }
    return false;
  }

  nextOption() {
    const currentIndex = this.shopItemDefinition.options.indexOf(
      this.currentOption.uuid
    );
    if (currentIndex + 1 < this.shopItemDefinition.options.length) {
      const nextOption = this.shopItemDefinitionsOptions.find(
        (x) => x.uuid === this.shopItemDefinition.options[currentIndex + 1]
      );
      return nextOption.nameTranslationKey;
    }
    return false;
  }

  updatePreview() {
    // 1. Go over every saved option
    Object.keys(this.cart.current.itemOptions).forEach((key) => {
      // 2. Find out the type
      const option = this.shopItemDefinitionsOptions.find(
        (x) => x.uuid === key
      );
      // 3. If the type is supported by Revolva, update it !
      if (
        ["shop.option.bag.type", "shop.option.bag.color"].includes(
          option.nameTranslationKey
        )
      ) {
        actions.changePiecesInScene(
          this.revolva,
          Object.keys(this.cart.current.itemOptions[key])[0],
          option.nameTranslationKey
        );
      } else if (option.nameTranslationKey === "shop.option.bag.card") {
        actions.changePiecesInScene(
          this.revolva,
          process.env.VUE_APP_BACKEND_URL +
            "/card/" +
            this.cart.current.itemOptions[key]["card"],
          option.nameTranslationKey
        );
      }
    });
  }
}
